module.exports = __webpack_public_path__ + "img/paper.66ea896d.svg";